'use strict';

var StepSposDirective = function StepSposDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/step-spos.html')
  };
};
StepSposDirective.$inject = [];
module.exports = StepSposDirective;